import UpdateMeditationTranslationRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/UpdateMeditationTranslationRequest";
import UpdateVoiceFileRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/UpdateVoiceFileRequest";
import MeditationAudioViewModel from "./meditationAudioViewModel";

export default class AudioGroupViewModel {
    audios: Array<MeditationAudioViewModel> = [];
    private paidValue: boolean | null = null;

    private hasAudioContent(audio: MeditationAudioViewModel): boolean {
        return !!(
            audio &&
            (
                audio.id ||
                audio.base64File ||
                audio.audioFile ||
                audio.audioUrl ||
                (audio.name || '').trim() ||
                (audio.description || '').trim()
            )
        );
    }

    get isPaid(): boolean {
        if (this.paidValue !== null) {
            return this.paidValue;
        }
        const filledAudios = (this.audios || []).filter(x => this.hasAudioContent(x));
        return filledAudios.length > 0 && filledAudios.every(x => x.isPaid);
    }
    set isPaid(v: boolean) {
        this.paidValue = v;
        this.audios.forEach(x => x.isPaid = v);
    }
    constructor(private languages: string[]) {
        this.audios = this.languages.map(l => new MeditationAudioViewModel({
            langCode: l
        }));
    }
    toServerModel(): UpdateMeditationTranslationRequest[] {
        const langs: string[] = [];
        this.audios.forEach(x => {
            if (langs.indexOf(x.langCode) == -1)
                langs.push(x.langCode)
        });
        const res = langs.map(x => new UpdateMeditationTranslationRequest({
            LangCode: x,
            VoiceFiles: this.audios.map(x => x.toServerModel())
        }));
        return res;
    }
    clone(): AudioGroupViewModel {
        const clone = new AudioGroupViewModel(this.languages)
        clone.audios = this.audios.map(x => x.clone());
        clone.isPaid = this.isPaid;
        return clone;
    }
}
